import React, { forwardRef, useState } from 'react';
const DatePickerInput = forwardRef((data, ref) => {
    const [readOnly, setReadOnly] = useState(false);
    return (
        <div className='date-picker-input-wrapper store-field-wrapper arrow-down_icon-wrapper' onClick={data.onClick} ref={ref} >
            <input className="store-field" placeholder={data.placeholder} autoComplete="off" value={data.value} onChange={data.onChange}
                    onFocus={() => setReadOnly((window.innerWidth <= 760))}
                    onBlur={() => setReadOnly(false)}
                    readOnly={readOnly} />
            <div className="arrow-down_icon" />
        </div>
    );
});

export default DatePickerInput